import info from "../../data/info"
import telegram from "../../img/Telegram_logo.svg.webp"
import viber from "../../img/viber2.webp"
import instagram from "../../img/Instagram_icon.png.webp"
import { logMessage } from "../../utils/utils"

const SocialNetButtons = () => {
  return (
    <div className="flex items-center animate-pulse">
      <a
        href={info.telegram}
        target="_blank"
        className="hover:scale-125 duration-300 max-w-[53px]"
        onClick={() => logMessage("Телеграм")}
      >
        <img src={telegram} />
      </a>
      <a
        href={info.viber}
        target="_blank"
        className="hover:scale-125 duration-300 max-w-[56px] ml-4"
        onClick={() => logMessage("Вайбер")}
      >
        <img src={viber} />
      </a>
      {info.instagram && (
        <a
          href={info.instagram}
          target="_blank"
          className="hover:scale-125 duration-300 max-w-[53px] ml-4"
          onClick={() => logMessage("Інстаграм")}
        >
          <img src={instagram} />
        </a>
      )}
    </div>
  )
}

export default SocialNetButtons
